module.exports = __webpack_public_path__ + "media/images/arr_b-19182ccc188004f92fe333e73df17950.svg";